import React, { useEffect, useState } from "react";

import styles from "./ProductInfoModal.module.scss";

import { useProductInfoModal } from "../stores/productModalStore";
import OrderDetails from "./OrderDetails";

function ProductInfoModal() {
  const [mount, setMount] = useState(false);
  const [style, setStyle] = useState({ opacity: 0 });
  const [dropdownStyle, setDropdownStyle] = useState({
    transform: "translateY(-100%)",
  });
  const { showProductInfoModal, setShowProductInfoModal } =
    useProductInfoModal();

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape") {
        setShowProductInfoModal(false);
      }
    }

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showProductInfoModal]);

  useEffect(() => {
    if (showProductInfoModal) {
      setMount(true);

      setTimeout(() => {
        setStyle({ opacity: 1 });
        setDropdownStyle({
          transform: "translateY(0%)",
        });
      }, 20);
    } else {
      if (mount) {
        setStyle({ opacity: 0 });
        setDropdownStyle({
          transform: "translateY(-100%)",
        });

        setTimeout(() => {
          setMount(false);
        }, 300);
      }
    }

    return () => {};
  }, [showProductInfoModal, mount]);

  return mount ? (
    <div className={styles.container}>
      <div
        className={styles.overlay}
        style={style}
        onClick={() => {
          setShowProductInfoModal(false);
        }}
      />

      <div className={styles.orderDetailsWrapper} style={dropdownStyle}>
        <section className={styles.orderDetails}>
          <OrderDetails />
        </section>
      </div>
    </div>
  ) : null;
}

export default ProductInfoModal;
